import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  residentList: [],
  residentListCount: 0,
  creditnoteReportByIdList: {},
};

export default function creditnoteReportReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_RESIDENTSDATA_SUCCESS_ACTION:
      return {
        ...state,
        residentList: action.payload,
        residentListCount: action.payload.length,
      };

    default:
      return {
        ...state,
      };
  }
}
